import apiClient from '../apiClient';
import { UPLOAD_COMMIT_EXCURSION_OBJECT_URL } from '../apiUrl';

const uploadMasterExcursionObjectApi = data => {
  return apiClient.post(UPLOAD_COMMIT_EXCURSION_OBJECT_URL, data);
};

export default uploadMasterExcursionObjectApi;
